import Request from 'gd-request';

class ApiWorkload {

    constructor() {}

    getData(id, startDate, endDate) {
        return new Request(this,'POST','board/workload/'+id, {
            startDate: startDate.format("YYYY-MM-DD"),
            endDate: endDate.format("YYYY-MM-DD"),
        });
    }

    changeWorkload(userId, taskId, workload) {
        return new Request(this,'POST','resource-allocation', {
            userId: userId,
            taskId: taskId,
            workload: workload
        });
    }

    getDummyData() {
        return []
    }
}


module.exports = ApiWorkload;